import React from 'react';
import './RejectionNotesDrawer.css';
import closeIcon from "../../assets/images/closeIcon.svg";
import Loader from '../subComponents/Loader';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import { IconButton } from '@mui/material';
import { t } from '../../locales/translate';

const RejectionNotesDrawer = ({ isOpen, onClose, rejectPlanDetails }) => {

    const isLoading = rejectPlanDetails === "isLoading";

    const notes = !isLoading && rejectPlanDetails && rejectPlanDetails.result ?
        rejectPlanDetails.result : [];
    return (
        <>

            <div className={`rejection-drawer-backdrop ${isOpen ? 'open' : ''}`} onClick={onClose}></div>

            <div className={`rejection-drawer-container ${isOpen ? 'open' : ''}`}>
                <div className="rejection-drawer-header">
                    <BodyLargeMedium text={t("rejectionNotes")} />
                    <IconButton onClick={onClose}>
                    <img src={closeIcon} />
                    </IconButton>
                </div>

                <div className="rejection-drawer-content">
                    {isLoading ? (
                        <Loader colored={true} />
                    ) : (
                        notes.length > 0 ? (
                            notes.map((note, index) => (
                                <div key={index} className="rejection-note">
                                    <div className="note-header">
                                        <div className="user-info">
                                            <div className="avatar-circle ">
                                                {note.rejectedByName ? note.rejectedByName.charAt(0) : 'U'}
                                            </div>
                                            <div>
                                                <BodyLargeMedium text={note.rejectedByName} />
                                            </div>
                                        </div>
                                        <BodyExtraSmallMedium
                                            text={note.revisionDate
                                                ? new Date(note.revisionDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })
                                                : ''}
                                        />

                                    </div>
                                    <BodySmallMedium text={note.message || ''} />
                                    <hr /> 
                                </div>
                            ))
                        ) : (
                            <div className="no-notes">{t("noRejectionNotes")}</div>
                        )
                    )}
                </div>
            </div>
        </>
    );
};

export default RejectionNotesDrawer;